<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone esquerda"><a @click="this.$router.back();" style="cursor: pointer;"
                    class="icone-voltar m-d"></a></div>
            <h2>Reuniões - Temas em Agenda</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="margem bloco">
            <fieldset class="grid-4">
                <div>
                    <label>Data inicio</label>
                    <input type="date" v-model="tema.dataInicio" :required="!tema.dataInicio"
                        @change="alteraçãoPendente = true">
                </div>
                <div>
                    <label>Data Fim</label>
                    <input type="date" v-model="tema.dataFim" :required="!tema.dataFim"
                        @change="alteraçãoPendente = true">
                </div>
                <div class="col-2">
                    <label>Tema</label>
                    <textarea v-model="tema.descricao" :required="!tema.descricao"
                        @change="alteraçãoPendente = true"></textarea>
                </div>
                <div class="col-2">
                    <label>Setores <i title="É necessário ao menos um setor" v-if="tema.setores?.length == 0"
                            class="bi-exclamation-diamond-fill"></i></label>
                    <div class="tags">
                        <a v-for="s, index in tema.setores" :key="index">{{ formatarNome(s.nome) }} <i
                                @click="removerSetor(s.id)" class="bi-trash"></i></a>
                        <a class="container-adicionar-setor">
                            <select class="adicionar-setor" style="width: 9rem;" v-model="novoSetor"
                                @change="novoSetor == 'todos' ? (tema.setores = setores, novoSetor = null) : adicionarSetor()">
                                <option :value="null" hidden>Adicionar Setor</option>
                                <option :value="'todos'">Todos</option>
                                <option v-for="item in setores.filter(s => !tema.setores.map(i => i.id).includes(s.id))"
                                    :key="item.id" :value="item">
                                    {{ item.nome }}
                                </option>
                            </select>
                        </a>
                    </div>
                </div>
                <div class="col-2">
                    <label>Tipos <i title="É necessário ao menos um tipo" v-if="modoCriação && tema.tipos?.length == 0"
                            class="bi-exclamation-diamond-fill"></i></label>
                    <div class="tags">
                        <a v-for="t, index in tema.tipos" :key="index">{{ t.descricao }} <i @click="removerTipo(t.id)"
                                class="bi-trash"></i></a>
                        <a class="container-adicionar-setor">
                            <select class="adicionar-setor" v-model="novoTipo" @change="adicionarTipo()"
                                style="width: 10rem;">
                                <option hidden :value="null">Adicionar Tipo</option>
                                <option v-for="item in tipos" :key="item.id" :value="item"
                                    :hidden="tema.tipos.some(t => t.id == item.id)">
                                    {{ item.descricao }}
                                </option>
                            </select>
                        </a>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="bloco margem">
            <h3>Anexos</h3>
            <div class="tags submit">
                <a v-for="a, index in tema.anexos" :key="index" target="_blank"
                    :href="a.path ? `${urlFoto}/${a.path}` : null">{{ a.name
                        ?? a.nome }} <i @click.stop.prevent="removerAnexo(a)" class="bi-trash"></i></a>
                <a @click="abrirInput">+</a>
                <input style="display: none" ref="fileInput" type="file" @change="adicionarArquivo">
            </div>
        </div>
        <div class="bloco margem">
            <h3>Pautas <i title="É necessário ao menos uma pauta" v-if="tema.pautas?.length == 0"
                    class="bi-exclamation-diamond-fill"></i></h3>
            <fieldset class="grid-1">
                <div v-for="p, index in tema.pautas" :key="index">
                    <div style="justify-content: space-between" class="alinha-v">
                        <label>Pauta {{ index + 1 }}</label>
                        <i class="bi-x-circle" @click="removerPauta(p)"></i>
                    </div>
                    <textarea :required="!p.descricao" v-model="p.descricao"
                        @change="alteraçãoPendente = true"></textarea>
                </div>
            </fieldset>
            <div class="submit">
                <button class="acao-secundaria" @click="adicionarPauta()">Adicionar</button>
            </div>
        </div>
        <div class="submit direita m-b">
            <button @click="modoCriação ? salvarTema() : atualizarTema()" :disabled="composVazios || !alteraçãoPendente"
                :title="!alteraçãoPendente ? 'Nenhuma alteração pendente' : composVazios ? 'Preencha os campos destacados' : ''">Salvar</button>
        </div>
    </div>
</template>

<script>
import service from '@/services/serviceReuniões'
import { getSetoresHieraquico } from "@/services/serviceSetores.js"
import { ref } from 'vue'
import { urlFoto } from "@/services/api"

export default {
    props: {
        id: {
            required: true,
        },
    },
    data() {
        return {
            tema: {},
            novoSetor: null,
            novoTipo: null,
            setores: [],
            tipos: [],
            urlFoto: urlFoto.caminhoFoto,
            alteraçãoPendente: false
        }
    },
    computed: {
        modoCriação() {
            return this.id == 'criar'
        },
        composVazios() {
            const camposParaValidar = ['dataInicio', 'dataFim', 'descricao'];
            var camposVazios = []
            camposParaValidar.forEach(campo => {
                if (this.tema[campo] == null || this.tema[campo] == '') {
                    camposVazios.push(campo)
                }
            })
            if (this.tema.setores?.length == 0) {
                camposVazios.push('setores')
            }
            if (this.tema.tipos?.length == 0) {
                camposVazios.push('tipos')
            }
            if (this.tema.pautas?.length == 0) {
                camposVazios.push('pautas')
            } else {
                this.tema.pautas?.forEach(pauta => {
                    if (pauta.descricao == null || pauta.descricao == '') {
                        camposVazios.push('pautas')
                    }
                })
            }
            return camposVazios.length > 0
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.alteraçãoPendente) {
            const resposta = window.confirm('Você tem alterações não salvas. Deseja sair mesmo assim?');
            if (resposta) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    },
    setup() {
        const fileInput = ref(null);

        const abrirInput = () => {
            fileInput.value.click();
        };

        return { fileInput, abrirInput };
    },
    async created() {
        this.tema = await service.buscarTema(this.id);
        this.setores = await getSetoresHieraquico();
        this.setores = this.setores.map(setor => ({
            id: setor.id,
            nome: this.formatarNome(setor.nome)
        })).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
        this.tipos = await service.getTipos();
    },
    mounted() {
        window.addEventListener('beforeunload', this.alertaSaida);
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.alertaSaida);
    },
    methods: {
        formatarNome(nome) {
            return nome.replace(/^(\d+\.*\s*)+/, '')
        },
        alertaSaida(event) {
            if (this.alteraçãoPendente) {
                event.preventDefault();
                event.returnValue = '';
            }
        },
        async atualizarTema() {
            const formData = new FormData();

            formData.append('status', 1);
            formData.append('_method', 'PATCH');

            this.tema.setores.forEach((setor, index) => {
                formData.append(`setores[${index}]`, setor.id);
            });
            this.tema.tipos.forEach((tipo, index) => {
                formData.append(`tipos[${index}]`, tipo.id);
            });
            this.tema.pautas.forEach((pauta, index) => {
                if (pauta.id) {
                    formData.append(`pautas[${index}][id]`, pauta.id);
                    formData.append(`pautas[${index}][descricao]`, pauta.descricao);
                } else {
                    formData.append(`pautas[${index}][descricao]`, pauta.descricao);
                }
            });

            for (let key in this.tema) {
                if (['setores', 'pautas', 'tipos', 'anexos', 'status'].includes(key)) continue;

                const value = this.tema[key];
                if (value !== null && value !== undefined) {
                    formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
                }
            }

            this.tema.anexos.filter(a => !a.anexoNovo).forEach((file, index) => {
                formData.append(`anexosExistentes[${index}]`, file.id);
            });

            this.tema.anexos.filter(a => a.anexoNovo).forEach((file, index) => {
                formData.append(`anexosNovos[${index}]`, file);
            });

            await service.atualizarTema(this.id, formData);
            this.alteraçãoPendente = false
        },
        async salvarTema() {
            const formData = new FormData();
            formData.append('status', 1);
            this.tema.setores.forEach((setor, index) => {
                formData.append(`setores[${index}]`, setor.id);
            });
            this.tema.pautas.forEach((pauta, index) => {
                formData.append(`pautas[${index}]`, pauta.descricao);
            });
            this.tema.tipos.forEach((tipo, index) => {
                formData.append(`tipos[${index}]`, tipo.id);
            });

            for (let key in this.tema) {
                if (['setores', 'pautas', 'tipos', 'anexos'].includes(key)) continue;

                const value = this.tema[key];
                if (value !== null && value !== undefined) {
                    formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
                }
            }

            this.tema.anexos.forEach((file, index) => {
                formData.append(`anexos[${index}]`, file);
            });

            await service.gravarTema(formData);
            this.alteraçãoPendente = false
            this.$router.push({ name: 'temasTemporarios' })
        },
        adicionarSetor() {
            this.tema.setores.push(this.novoSetor);
            this.novoSetor = null;
            this.alteraçãoPendente = true;
        },
        removerSetor(id) {
            this.tema.setores = this.tema.setores.filter(s => s.id != id)
            this.alteraçãoPendente = true;
        },
        adicionarTipo() {
            this.tema.tipos.push(this.novoTipo);
            this.novoTipo = null;
            this.alteraçãoPendente = true;
        },
        removerTipo(id) {
            this.tema.tipos = this.tema.tipos.filter(t => t.id != id)
            this.alteraçãoPendente = true;
        },
        adicionarPauta() {
            var pauta = { descricao: '' }
            this.tema.pautas.push(pauta)
            this.alteraçãoPendente = true;
        },
        removerPauta(item) {
            this.tema.pautas = this.tema.pautas.filter(p => p != item)
            this.alteraçãoPendente = true;
        },
        adicionarArquivo(event) {
            event.target.files[0].anexoNovo = true
            this.tema.anexos.push(event.target.files[0]);
            this.alteraçãoPendente = true;
        },
        removerAnexo(item) {
            this.tema.anexos = this.tema.anexos.filter(a => a != item)
            this.alteraçãoPendente = true;
        },
    },
}
</script>

<style scoped>
.tags a i {
    display: none;
}

.tags a:hover i {
    display: inline;
}

.container-adicionar-setor {
    padding: 5px;
}

.adicionar-setor {
    height: 2rem;
    font-weight: bold;
    padding: 0 16px;
    border: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: transparent !important;
}

i {
    color: var(--cor-erro);
    font-size: 16px;
    transition: all 200ms ease-in;
}

i:hover {
    cursor: pointer;
    transform: scale(1.1);
}
</style>